import React from 'react'
import { Toast } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { deleteToast, selectResponseNotification } from '../../slices/responseNotification.slice';

const ResponseNotification = () => {
  const dispatch = useAppDispatch();

  const notificationArray = useAppSelector(selectResponseNotification);

  const generateBackgroundColor = (type: string) => {
    switch (type.toLowerCase()) {
      case "info":
        return "#5bc0de";
      case "warning":
        return "#f0ad4e";
      case "danger":
        return "#d9534f";
      case "success":
        return "#5cb85c";
      default:
        return;
    }
  };

  return (
    <div className='notification-container'>
      {notificationArray.map((data) => (
        <Toast
          style={{
            backgroundColor: generateBackgroundColor(data.type),
          }}
          className='notification'
          key={data.id}
          onClose={() => dispatch(deleteToast(data.id))} delay={4000} autohide>
          <Toast.Body>{data.message}</Toast.Body>
        </Toast>
      ))}
    </div>
  )
}

export default ResponseNotification;